<loader-overlay-component [show]="isloading"></loader-overlay-component>
<div class="mainBody">
    <div class="dmv-search-results inner-home">
        <div class="container">
            <div class="row no-margin">
                <div class="col-6 col-sm-2 mt-4"><a><button class="btn btn-primary btn-back top-back-button" (click)="back()"><i
                                class="fa fa-chevron-left text-left"></i> Back</button></a></div>
                <div class="col-12 col-sm-8 mt-4">
                    <div id="searchResu">Edit Contact Info</div>
            
                </div>
                <div class="col-6 col-sm-2 icon-cart mt-4">

                </div>
                <div class="col-12 alert alert-danger" role="alert" *ngIf="errorMessage" > &nbsp;<span [innerHTML]="errorMessage"></span></div>
                <form autocomplete="off" class="text-left mb-b" [formGroup]="editContactForm">
                    <div class="col-12 asteriskMessage"> *Fields marked with an asterisk are required </div>
                     
                    <div class="row no-margin">
                        <!-- <div class="col-12 alert-danger" role="alert"> Please correct fields in error. </div>
                        <div class="col-12 asteriskMessage"> *Fields marked with an asterisk are required </div> -->
                        <div class="col-12 col-sm-12 mb-4">
                            <label  class="lblPin">Email Address</label>
                            <div><input disabled class="form-control" value="{{userStoreService?.getUserProfile()?.contactInfo?.emailAddress}}"/>
                                </div>
                        </div>
                        <div class="col-12 col-sm-6 mb-4">
                            <label  class="lblPin">First Name OR Business Name*</label><input (blur)="globalService.trimValue(f.firstName)" class="form-control" formControlName="firstName" [ngClass]="{ 'is-invalid': submitted && f.firstName.errors }">
                            <div *ngIf="submitted && f.firstName.errors && f.firstName.errors"  class="invalid-feedback">Please enter First Name OR Business Name.</div>
                        </div>
                        <div class="col-12 col-sm-6 mb-4">
                            <label  class="lblPin">Last Name</label><input class="form-control" (blur)="globalService.trimValue(f.lastName)" formControlName="lastName">
                        </div>
                        <div class="col-12 col-sm-6">
                            <label  class="lblPin">Phone Number</label><input [textMask]="{mask: phoneMask}" (input)="toggleMobile()" class="form-control" formControlName="phoneNumber" >
                       
                            <div class="mt-3">
                            
                                <div class="checkbox-container mobilePhone " [ngClass]="{ 'disabled ': !f.phoneNumber.value }">
                                    <label class="d-block cursorPonter">
                                        <span for="mobile" class="checkboxLabel">This is a mobile phone</span>
                                        <input type="checkbox" [attr.disabled] ="!f.phoneNumber.value  ? 'disabled' : null"    name="mobile" formControlName="mobile">
                                        <span class="checkmark-default" ></span>             
                                     </label> 
                                </div>  
    
                                
                            </div>
                        </div>
                    
                        <div class="col-12 col-lg-6 col-md-6 col-sm-6 mb-4">
                            <label  class="lblPin">Tax Collector County* </label>
                            <div class="select-wrapper-3 monthpicker m-auto"><select
                                class="form-control"  (click)="globalService.selectChange($event)" (keydown)="globalService.selectChangeByKey($event)" (change)="globalService.setDownIcon($event)"  (blur)="globalService.setDownIcon($event)"  formControlName="collectorCounty"  [ngClass]="{ 'is-invalid': submitted && f.collectorCounty.errors }">
                                
                                <option value="">Select a County</option>
                                <option *ngFor='let agency of (megStoreService.configurationsData$ | async)?.megConfig?.agencies'
                                [value]="agency.agencyID">
                                {{agency.name}}
                              </option>
                            </select>
                            <div class="invalid-feedback">Please select a tax collector county</div>
                        </div>
                        </div>
                        <div class="col-12 col-lg-6 col-md-6 col-sm-6 mb-4">
                            <label  class="lblPin">ADDRESS LINE 1</label><input class="form-control" (blur)="globalService.trimValue(f.mailingAddress)" (change)="(addressValidationCheck())"  formControlName="mailingAddress"[ngClass]="{ 'is-invalid': submitted && f.mailingAddress.errors }">
                            <div *ngIf="submitted && f.mailingAddress.errors && f.mailingAddress.errors"  class="invalid-feedback">Please enter Address Line 1.</div>
                        </div>
                        <div class="col-12  col-lg-6 col-md-6 col-sm-6 mb-4">
                            <label  class="lblPin">City</label>
                            <input class="form-control" (change)="(addressValidationCheck())" (blur)="globalService.trimValue(f.city)"  formControlName="city" [ngClass]="{ 'is-invalid': submitted && f.city.errors }">
                            <div *ngIf="submitted && f.city.errors && f.city.errors"  class="invalid-feedback">Please enter City.</div>
                        </div>
                        <div class="col-12  col-lg-6 col-md-6 col-sm-6 mb-4">
                            <label  class="lblPin">Select a State</label>
                            <div class="select-wrapper-3 monthpicker m-auto">
                               
                            <select class="form-control " (click)="globalService.selectChange($event)" (keydown)="globalService.selectChangeByKey($event)" (change)="globalService.setDownIcon($event); addressValidationCheck()"  (blur)="globalService.setDownIcon($event)"  formControlName="state" [ngClass]="{ 'is-invalid': submitted && f.state.errors }" >

                                
                                <option  [value]="''" >Select Your State</option>       
                                <option [value]="item.alpha" *ngFor='let item of dmvStoreService?.states'>{{item.name}}</option>
                            </select>  
                            <div class="invalid-feedback">Please select a State</div>
                        </div>
                        </div>
                        <div class="col-12  col-lg-6 col-md-6 col-sm-6 mb-4">
                            <label  class="lblPin">Zip</label>
                            <input class="form-control" (change)="(addressValidationCheck())" (blur)="globalService.trimValue(f.zip)" formControlName="zip"  [ngClass]="{ 'is-invalid': submitted && f.zip.errors }">
                            <div *ngIf="submitted && f.zip.errors && f.zip.errors"  class="invalid-feedback">Please enter Zip.</div>
                        </div>
                        <div class="col-12  col-lg-6 col-md-6 col-sm-6 mb-4">
                            <label  class="lblPin">DATE OF BIRTH (MM/DD/YYYY FORMAT)</label>
                            <input class="form-control" #dateOfBirth [textMask]="{mask: mask}" placeholder="mm/dd/yyyy" formControlName="dateOfBirth" [ngClass]="{ 'is-invalid': submitted && f.dateOfBirth.errors }">
                            <div *ngIf="submitted && f.dateOfBirth.errors && f.dateOfBirth.errors.pattern"  class="invalid-feedback">Please enter date of birth in mm/dd/yyyy formate.</div>
                            <div *ngIf="submitted && f?.dateOfBirth?.errors?.invalid"  class="invalid-feedback">Invalid date of birth</div>
                        </div>
                      
                       
                    </div>

                   
                </form>
            </div>

            <div class="container m-auto text-center"><a><button class="btn btn-primary btn-back" (click)="cancel()"> Cancel</button></a><a><button
                        class="btn btn-primary  btn-continue m-auto" (click)="save()">Save </button></a></div>
        </div>
    </div>
</div>